import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import useCompanyProfile from "../company-profile.hooks";
import style from "../operational-date.module.css";
import CustomTable from "../../../../component/table/CustomTable";
import moment from "moment";
import { useTranslation } from "react-i18next";
import DropdownList from "../../../../component/dropdown/DropdownList";
import _ from "lodash";
import { AddIcon } from "../../../../asset/icons";
import { DeleteIcon, EditIcon } from "../../../../asset";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import LogoutModal from "../../../../component/modal/LogoutModal";
import ModalDateCompany from "../../../../component/modal/ModalDateCompany";
import dayjs from "dayjs";
import Delete from "../../../../component/modal/ModalDelete";

const EditOperationalDate = ({ setOperationalDateData, ...props }) => {
  const { operationalDate } = useCompanyProfile();
  const { t } = useTranslation();
  const [listData, setListData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dropdown, setDropdown] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedMonthId, setSelectedMonthId] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [tempData, setTempData] = useState([]);
  const [countIdAdd, setCountIdAdd] = useState(1);
console.log("operational date", props?.oprDate);
console.log("selected month", selectedMonth);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     let bulan = await getMonthId();
  //     await getDateByMonth(bulan);
  //   };
  //   currentMonth();
  //   if (_.isEqual(listData, filteredData) && props?.oprDate?.length > 0) {
  //     // console.log("<<<<<<<<<<<<<<<<<<   DATA   <<<<<<<<<<<<<<<<<<");
  //     currentMonth();
  //     options();
  //     setListData(props?.oprDate);
  //     setFilteredData(props?.oprDate);
  //     fetchData();
  //   }
  //   if (showEdit) {
  //   }
  // }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await getDateByMonth(getMonthId());
  //   };
  //   options();

  //   // console.log("<<<<<<<<<<<<<<<<<<   MONTH   <<<<<<<<<<<<<<<<<<");
  //   fetchData();

  //   // eslint-disable-next-line
  // }, [selectedMonth]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await getDateByMonth(getMonthId());
  //   };
  //   if (_.isEmpty(listData) || _.isEmpty(props?.oprDate)) {
  //     // console.log("<<<<<<<<<<<<<<<<<<   OPS   <<<<<<<<<<<<<<<<<<");
  //     setListData(props?.oprDate);
  //     setFilteredData(props?.oprDate);
  //     fetchData();
  //   } else if (!_.isEqual(props?.oprDate, listData)) {
  //     setListData(props?.oprDate);
  //     setFilteredData(props?.oprDate);
  //     fetchData();
  //   }
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      let bulan = await getMonthId();
      await getDateByMonth(bulan);
    };
    if (_.isEqual(listData, filteredData) && props?.oprDate.length > 0) {
      // console.log("<<<<<<<<<<<<<<<<<<   DATA   <<<<<<<<<<<<<<<<<<");
      currentMonth();
      options();
      setListData(props?.oprDate);
      setFilteredData(props?.oprDate);
      fetchData();
    }
    if (showEdit) {
    }
  }, []);

  useEffect(() => {
    currentMonth();
    const fetchData = async () => {
      await getDateByMonth(getMonthId());
    };
    options();

    // console.log("<<<<<<<<<<<<<<<<<<   MONTH   <<<<<<<<<<<<<<<<<<");
    fetchData();

    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      await getDateByMonth(getMonthId());
    };
    options();

    // console.log("<<<<<<<<<<<<<<<<<<   MONTH   <<<<<<<<<<<<<<<<<<");
    fetchData();

    // eslint-disable-next-line
  }, [selectedMonth]);

  useEffect(() => {
    const fetchData = async () => {
      await getDateByMonth(getMonthId());
    };
    if (_.isEmpty(listData) || _.isEmpty(props?.oprDate)) {
      // console.log("<<<<<<<<<<<<<<<<<<   OPS   <<<<<<<<<<<<<<<<<<");
      setListData(props?.oprDate);
      setFilteredData(props?.oprDate);
      fetchData();
    } else if (!_.isEqual(props?.oprDate, listData)) {
      setListData(props?.oprDate);
      setFilteredData(props?.oprDate);
      fetchData();
    }
    // eslint-disable-next-line
  }, []);

  const currentMonth = async () => {
    console.log("selected month kesini");
    let date = moment();
    let month = date.format("MMMM YYYY");
    
    console.log("selected month kesini month", month);
    setSelectedMonth(month);
    await getDateByMonth(getMonthId());
  };

  const getMonthId = () => {
    let selectedCode = "";
    dropdown?.forEach((data) => {
      if (data.label === selectedMonth) selectedCode = data.id;
    });
    setSelectedMonthId(selectedCode);
    return selectedCode;
  };

  const options = async () => {
    let date = moment();
    let monthInNumber = date.format("M");
    let year =
      Number(monthInNumber) === 12
        ? Number(date.format("YYYY")) + 1
        : date.format("YYYY");
    var months = moment.months();

    let nextYear = {
      id: "M" + (months.length + 1),
      value: months[0] + " " + (Number(year) + 1),
      label: months[0] + " " + (Number(year) + 1),
    };

    let lastYear = {
      id: "M00",
      value: months[months.length - 1] + " " + (year - 1),
      label: months[months.length - 1] + " " + (year - 1),
    };

    let list = months.map((item, idx) => {
      return {
        id: idx > 10 ? "M" + (idx + 1) : "M0" + (idx + 1),
        value: item + " " + year,
        label: item + " " + year,
      };
    });

    list.push(nextYear);
    list.unshift(lastYear);

    setDropdown(list);
  };

  const onChange = async (e) => {
    console.log("chehc etv", e.target.value);
    setSelectedMonth(e.target.value);
  };

  const getDateByMonth = async (id, list) => {
    let array = list ? list : listData;
    let dateByMonth = [];
    if (id) {
      array?.forEach((data) => {
        if (
          data.date_start_code === id ||
          checkCode(data.date_start_code, data.date_end_code, id)
        )
          dateByMonth.push(data);
      });

      await setFilteredData(dateByMonth);
    }
  };

  const checkCode = (start, end, id) => {
    let code = Number(id.split("-")[0].split("M")[1]);
    if (end) {
      let startMonth = Number(start.split("M")[1]);
      let endMonth = Number(end.split("M")[1]);

      if (startMonth <= code && code <= endMonth) {
        return true;
      }
    }
    return false;
  };

  const ListColumn = [
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMPANY_PROFILE:DATE")}
        </span>
      ),
      dataIndex: "date",
      key: "date",
      render: (date) => <span>{date}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMPANY_PROFILE:DAYS")}
        </span>
      ),
      dataIndex: "days",
      key: "days",
      render: (days) => <span>{days}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMPANY_PROFILE:EVENT_NAME")}
        </span>
      ),
      dataIndex: "event_name",
      key: "event_name",
      render: (event_name) => <span>{event_name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222]">
          {t("Type of Status")}
        </span>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => status,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMPANY_PROFILE:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];

  const getDate = (start, end) => {
    if (start === end) {
      return start;
    } else {
      if (
        dayjs(start).format("YYYY-MM-DD") === dayjs(end).format("YYYY-MM-DD")
      ) {
        return dayjs(start).format("YYYY-MM-DD");
      }
      return (
        dayjs(start).format("YYYY-MM-DD") +
        " - " +
        dayjs(end).format("YYYY-MM-DD")
      );
    }
  };

  const getDays = (start, end) => {
    const day_start = dayjs(start).format("dddd");
    const day_end = dayjs(end).format("dddd");
    if (day_start === day_end) {
      return day_start;
    } else {
      return day_start + " - " + day_end;
    }
  };

  const getEvent = (eventName) => {
    if (eventName?.includes("_")) {
      return eventName.split("_")[1];
    }
    return eventName;
  };

  const getStatus = (eventName, status) => {
    console.log("eventname", eventName, status);
    if (eventName?.includes("_")) {
      return "Public Holidays";
    }
    return (status===true || status ==="Y")? "Working Days" : "Holidays";
  };

  const setModal = async (data) => {
    await setSelectedData(data);
    await setShowDelete(true);
  };

  console.log("check filtered data", _.map(filteredData,(result)=>{getStatus(result?.description, result?.is_operational_active)}));
console.log("check loop", _.filter(filteredData,(el)=>!el?.is_deleted));
  const dataSource =
    filteredData.length > 0
      ? _.filter(filteredData,(el)=>!el?.is_deleted)?.map((result) => 
      // !result?.is_deleted ?
      ({
          date: (
            <span className="font-roboto text-lg text-[#222222]">
              {getDate(result?.date_start, result?.date_end)}
            </span>
          ),
          days: (
            <span className="font-roboto text-lg text-[#222222]">
              {getDays(result?.date_start, result?.date_end)}
            </span>
          ),
          event_name: (
            <span className="font-roboto text-lg text-[#222222]">
              {getEvent(result?.description)}
            </span>
          ),
          status:
            getStatus(result?.description, result?.is_operational_active) ===
            "Working Days" ? (
              <span className="font-roboto text-lg">
                <div
                  style={{
                    background: "#FF00001A",
                    color: "#FF0000",
                  }}
                  className="rounded-[9px] text-roboto text-[16px] w-fit py-[2px] px-[6px]"
                >
                  Working Days
                </div>
              </span>
            ) : getStatus(
                result?.description,
                result?.is_operational_active
              ) === "Public Holidays" ? (
              <span className="font-roboto text-lg">
                <div
                  style={{
                    background: "#eef9ea",
                    color: "#57c22d",
                  }}
                  className="rounded-[9px] text-roboto text-[16px] w-fit py-[2px] px-[6px]"
                >
                  Public Holidays
                </div>
              </span>
            ) : (
              <span className="font-roboto text-lg">
                <div
                  style={{
                    background: "#ecf6ff",
                    color: "#46A3FC",
                  }}
                  className="rounded-[9px] text-roboto text-[16px] w-fit py-[2px] px-[6px]"
                >
                  Holidays
                </div>
              </span>
            ),
          action: (
            <div className="flex gap-[26px]">
              <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
                <button
                  onClick={() => {
                    setSelectedData(result);
                    setShowEdit(true);
                  }}
                >
                  <img src={EditIcon} alt="edit" />
                </button>
              </Tooltip>
              <Tooltip title={t("Delete")} color="#CF0000">
                <button onClick={() => setModal(result)}>
                  <img src={DeleteIcon} alt="del" />
                </button>
              </Tooltip>
            </div>
          ),
        }) 
        // : null
        )
      : null;

  const doDeleteEvent = async () => {
    let findIndexUpdatedData = _.findIndex(
      updatedData,
      (el) => el?.id === selectedData?.id
    );
    console.log("IDX ",updatedData, findIndexUpdatedData,selectedData);

    let delData = [];

    if (selectedData?.id) {
      delData = [
        ...listData,
        {
          ...selectedData,
          is_deleted: true,
        },
      ];
      console.log("del", delData);
      await setUpdatedData(delData);
      props.updated(delData);
      await getUpdatedList(listData, delData);
    } else {
      let findIndexListData = _.findIndex(
        listData,
        (el) => el?.idAdd === selectedData?.idAdd
      );
      console.log("IDXLIST ", findIndexListData,listData,selectedData);
      _.pullAt(updatedData, findIndexListData);
      _.pullAt(listData, findIndexListData);

      await setUpdatedData(updatedData);
      props.updated(updatedData);
      
      console.log("UPdated DATA ", updatedData);
      await getUpdatedList(listData, updatedData);
    }
    await setShowDelete(false);
  };

  const getMessageConfirmDelete = () => {
    return (
      getEvent(selectedData?.description) +
      " (" +
      getDate(selectedData?.date_start, selectedData?.date_end) +
      ")"
    );
  };

  const getUpdatedList = async (oldList, newList) => {
    console.log("OLD", oldList);
    console.log("UPDATE", newList);
    const replaceObjectWithId=(objects, idToReplace, newObject)=> {
      for (let i = 0; i < objects.length; i++) {
          if (objects[i].id === idToReplace) {
              objects[i] = newObject;
              return true;
          }
      }
      return false;
  }

  const replaceObjectWithIdAdd=(objects, idToReplace, newObject)=> {
    for (let i = 0; i < objects.length; i++) {
        if (objects[i].idAdd === idToReplace) {
            objects[i] = newObject;
            return true;
        }
    }
    return false;
}
    let dateByMonth = [];
    let updtData=[]
    // oldList?.forEach((oldData) => {
    //   let update = _.filter(newList, (e) => {
    //     return e.idAdd === oldData.idAdd;
    //   });
    
    //   let findIndex = _.findIndex(update, (e) => e.id === oldData.id)
    //   let findIndex2 = _.findLastIndex(update, (e) => e.idAdd === oldData.idAdd)
    //   let findLastIndex = _.findLastIndex(update, (e) => e.id === oldData.id)
    //   console.log("DATA FILTER UPDATE ", update);
    // }
    // )
    //   console.log("findIndex",findIndex);
    //   console.log("findlASTIndex",findLastIndex);

    //   if (update.length > 0 && (_.findIndex(oldList, (e) => e.idAdd === newList[newList.length-1]?.idAdd)>=0 || _.findIndex(oldList, (e) => e.id === newList[newList.length-1]?.id)<0 )) {
    //     console.log("ADA PERUBAHAN DAN TIDAK TERHAPUS ");
    //     console.log(update);
    //     if (findIndex !== findLastIndex) {
    //       console.log("ADA PERUBAHAN DAN TIDAK TERHAPUS ");
    //       _.pull(dateByMonth, (el) => el.id === update[findIndex].id)
    //     }
    //     if(oldData.id){
    //     dateByMonth.push(update[findLastIndex]);
    //     }
    //     if(oldData.idAdd){
    //      dateByMonth.push(update[findIndex2]);
    //     }
    //     // console.log(update[findLastIndex]);
    //   } else if (update.length === 0 && !oldList.is_deleted) {
    //     console.log("ELSE ");
    //     dateByMonth.push(oldData);
    //   } else {
    //     console.log("DELETED");
    //   }
    // });

    console.log("DATE BY MONTH11 ", dateByMonth);
    if(_.findIndex(oldList, (e) => e.idAdd === (newList[newList.length-1]?.idAdd))<0){
      // let combinedArr = oldList.concat(newList);
      // if (new)
      // let news = [...oldList,newList.length===2 ? newList[0] :newList[newList.length-1]]
      let news = [...oldList,newList[newList.length-1]]
      console.log("ADD NEW ARRAY",newList.length,news);
      console.log("ADD DATA NEW",...oldList,newList[newList.length-1]);
      dateByMonth.push(news)
      // newList?.forEach((data)=>{
      //   if (data.idAdd === newList.length-1) {
      //     dateByMonth.push(data)
      //   }
      // })
    }else if(_.findIndex(oldList, (e) => e.idAdd === newList[newList.length-1]?.idAdd)>=0 || _.findIndex(oldList, (e) => e.id === newList[newList.length-1]?.id)>=0){
      if(newList[newList.length-1]?.id){
      replaceObjectWithId(oldList, newList[newList.length-1]?.id, newList[newList.length-1]);
      dateByMonth.push(oldList)
      
    console.log("CHECKUP4");
      }else{
        oldList?.forEach((oldData) => {
      let update = _.filter(newList, (e) => {
        return e?.idAdd === oldData?.idAdd;
      })
      
    // console.log("CHECKUP", update);
      updtData.push(update)
    })
    let mergedData = updtData.reduce((acc, val) => acc?.concat(val), []);
    const findIndexWithDifferentAttributes=(data1, data2)=> {
      let indexes = [];
      data2?.forEach(item2 => {
          data1?.forEach((item1, index) => {
              if (item1.idAdd === item2.idAdd) {
                  if (item1.description !== item2.description ||
                      item1.date_start !== item2.date_start ||
                      item1.date_end !== item2.date_end || 
                      item1.is_operational_active !== item2.is_operational_active) {
                      indexes.push(index);
                  }
                  // else{
                  //   indexes.push(-1);
                  // }
              }
          });
      });
      return indexes;
  }
// Cetak array hasil penggabungan
let indx = findIndexWithDifferentAttributes(mergedData,oldList)
console.log("CHECKUP2",indx);
    console.log("CHECKUP", updtData);
    if(indx>=0){
      replaceObjectWithIdAdd(oldList, newList[indx]?.idAdd, newList[indx]);
      dateByMonth.push(oldList)
    }else{
      dateByMonth.push(oldList)
    }
      }
    }else{
      dateByMonth.push(oldList)
    }


    
    // let add = _.filter(newList, (e) => {
    //   return !e.id;
    // });

    console.log("DATE BY MONTH ",dateByMonth.length, dateByMonth[dateByMonth.length-1]);

    // console.log("ADD ", add);
    // add?.forEach((data) => {
    //   if (!data.id && _.findIndex(nList, (e) => e.idAdd === newList[0]?.idAdd)) {
    //     dateByMonth.push(data);
    //   }
    // });

    // console.log("DATE BY MONTH ", dateByMonth);

  // await setListData(dateByMonth);
  // await getDateByMonth(getMonthId(), dateByMonth);
    await setListData(_.flattenDeep(dateByMonth.length ? dateByMonth[dateByMonth.length-1] : dateByMonth));
    await getDateByMonth(getMonthId(), _.flattenDeep(dateByMonth.length ? dateByMonth[dateByMonth.length-1] : dateByMonth));
  //   console.log("OLD", oldList);
  //   console.log("UPDATE", newList);
  //   let dateByMonth = [];
  //   oldList?.forEach((oldData) => {
  //     let update = _.filter(newList, (e) => {
  //       console.log("dalam foreach", e);
  //       console.log("old dalam foreach", oldData);
  //       console.log("return freach", e.id === oldData.id);
  //       return e.id === oldData.id;
  //     });
  //     console.log("DATA FILTER UPDATE ", update);

  //     if (update.length > 0 && !update?.is_deleted && !update?.flagAdd) {
  //       dateByMonth.push(update[0]);
  //     }
  //     else if(update.length > 0 && update?.is_deleted){
  //       dateByMonth.push(update[0]);
  //     }
  //      else if (update.length === 0 && !oldList.is_deleted) {
  //       console.log("ELSE ");
  //       dateByMonth.push(oldData);
  //     }
  //     // else if(update.length > 0 && !update?.is_deleted && !update?.flagAdd){
  //     //   dateByMonth.push(update[0]);
  //     // }
  //      else {
  //       console.log("DELETED");
  //     }
  //   });

  //   let add = _.filter(newList, (e) => {
  //     return !e.id;
  //   });

  //   // let diff = _.filter(dateByMonth, (e) => {
  //   //   return e.id;
  //   // });

  //   console.log("DATE BY MONTH ", dateByMonth);

  //   console.log("ADD ", add);

  //   add?.forEach((data) => {
  //     if (!data.id ) {
  //       dateByMonth.push(data);
  //     }
  //   });
  // //   add?.forEach((oldData) => {
  // //     // if (!oldData.id ) {
  // //     let updatess= _.filter(newList, (e) => {
  // //       console.log("dalam foreach", e);
  // //       console.log("old dalam foreach", oldData);
  // //       console.log("return freach", e.id === oldData.id);
  // //       return e.isAdd === oldData.isAdd;
  // //     });
       
  // //       diff.push(updatess[0]);
  // // console.log("after addd", diff);
  //   // }else if(oldData.length > 0 && !oldData?.is_deleted && !oldData?.flagAdd){
  //   //   // dateByMonth.push(oldData[0]);
  //   // }
  // // })

  //   console.log("DATE BY MONTH ", dateByMonth);
    
  //   console.log("DATE BY MONTH 2", dateByMonth);

  //   await setListData(dateByMonth);
  //   await getDateByMonth(getMonthId(), dateByMonth);

    // await setListData(dateByMonth);
    // await getDateByMonth(getMonthId(), dateByMonth);
 };

// const getUpdatedList = async (oldList, newList) => {
//   console.log("OLD", oldList);
//   console.log("UPDATE", newList);
//   let dateByMonth = [];
//   oldList?.forEach((oldData) => {
//     let update = _.filter(newList, (e) => {
//       return e.id === oldData.id;
//     });
//     console.log("DATA FILTER UPDATE ", update);

//     if (update.length > 0 && !update.is_deleted) {
//       console.log("ADA PERUBAHAN DAN TIDAK TERHAPUS ");
//       dateByMonth.push(update[0]);
//     } else if (update.length === 0 && !oldList.is_deleted) {
//       console.log("ELSE ");
//       dateByMonth.push(oldData);
//     } else {
//       console.log("DELETED");
//     }
//   });

//   let add = _.filter(newList, (e) => {
//     return !e.id;
//   });

//   console.log("DATE BY MONTH ", dateByMonth);

//   console.log("ADD ", add);

//   add?.forEach((data) => {
//     if (!data.id) {
//       dateByMonth.push(data);
//     }
//   });

//   console.log("DATE BY MONTH ", dateByMonth);

//   await setListData(dateByMonth);
//   await getDateByMonth(getMonthId(), dateByMonth);
// };

console.log("filteres", filteredData);
  const publicHolidays = (value, selectData) => {
    if (selectData?.description?.includes("PH_")) {
      if (value === "Holidays") {
        return selectData.description.split("_")[1];
      } else if (value === "Working Days") {
        return selectData.description.split("_")[1];
      } else if (value === "Public Holidays") {
        return selectData.description;
      }
    } else if (selectData?.description === undefined) {
      return;
    } else {
      if (value === "Public Holidays") {
        return _.join(["PH"].concat(selectData.description), "_");
      } else {
        return selectData.description;
      }
    }
  };

  const onChangeModalDate = (event, namespace) => {
    console.log(namespace);
    let value = event.target?.value;
    let findIndex = _.findIndex(
      filteredData,
      (el) => el.id === selectedData.id
    );
    if (selectedData === undefined) {
      if (namespace === "checkbox") {
        let isOperation;
        if (value === "Holidays") {
          isOperation = false;
        } else if (value === "Working Days") {
          isOperation = true;
        } else if (value === "Public Holidays") {
          isOperation = true;
        }
        setSelectedData((prevsValue) => ({
          ...prevsValue,
          [`${namespace}_code`]: getDateCode(
            dayjs(new Date(event)).format("YYYY-MM-DD")
          ),
          is_operational_active: isOperation,
        }));
      }
    } else {
      if (namespace === "checkbox") {
        let isOperation = filteredData.is_operational_active;
        let isDescription;
        if (value === "Holidays") {
          isOperation = false;
          isDescription = publicHolidays(value, selectedData);
        } else if (value === "Working Days") {
          isOperation = true;
          isDescription = publicHolidays(value, selectedData);
        } else if (value === "Public Holidays") {
          isDescription = publicHolidays(value, selectedData);
        }
        setSelectedData((prevsValue) => ({
          ...prevsValue,
          [`${namespace}_code`]: getDateCode(
            dayjs(new Date(event)).format("YYYY-MM-DD")
          ),
          is_operational_active: isOperation,
          description: isDescription,
        }));
      } else if (namespace === "input") {
        setSelectedData((prevsValue) => ({
          ...prevsValue,
          description: value,
        }));
      } else {
        setSelectedData((prevsValue) => ({
          ...prevsValue,
          [`${namespace}_code`]: getDateCode(
            dayjs(new Date(event)).format("YYYY-MM-DD")
          ),
          [namespace]: dayjs(new Date(event)).format("YYYY-MM-DD"),
        }));
      }
    }
  };

  const getDateCode = (date) => {
    let data = date.split("-");
    if (data[0] < selectedMonth.split(" ")[1]) {
      return "M00";
    } else if (data[0] > selectedMonth.split(" ")[1]) {
      return "M13";
    } else {
      return `M${data[1]}`;
    }
  };

  const CancelEdit = () => {
    setShowEdit(false);
    setSelectedData({});
  };

  const SaveDateCompany = async (data) => {
    console.log("saat add",data);
    if (data.description.length === 0) {
      return;
    }
    let findIndex = _.findIndex(
      filteredData,
      (el) => el.id === data.id
    );
    let findIndexAdd = _.findIndex(
      filteredData,
      (el) => el.idAdd === data.idAdd
    );
    if (findIndex === -1) {
      // WOI ZELDA INI UNTUK ADD
      console.log("NEW DATA FORM");
      let date_end = dayjs(data.date_end).format("YYYY-MM-DD");
      let date_start = dayjs(data.date_start).format("YYYY-MM-DD");
      let addData = [
        ...updatedData,
        {
          ...data,
          date_end,
          date_start,
        },
      ];
      setUpdatedData(addData);
      console.log("NEW DATA ", addData);
      await getUpdatedList(listData, addData);
      props.updated(addData);
      setCountIdAdd(countIdAdd + 1);
      setTempData({
        ...tempData,
        ...addData,
      });
    } else {
      console.log("ADA DATA");

      if (data.id === undefined) {
        console.log("ADA DATA TAPI HASIL ADD BARU");

        if (findIndexAdd !== -1) {
          console.log("EDIT DATA YANG HASIL ADD BARU");

          let findIndexUpdatedData = _.findIndex(
            updatedData,
            (el) => el.idAdd === data.idAdd
          );
          updatedData[findIndexUpdatedData] = data;

          console.log("NEW DATA 3", updatedData);
          await setUpdatedData(updatedData);
          props.updated(updatedData);
          await getUpdatedList(listData, updatedData);
          // filteredData[findIndexAdd] = {
          //   ...data,
          // };
        } else {
          console.log("ADA DATA SETELAH ADA DATA BARU");

          let date_end = dayjs(data.date_end).format("YYYY-MM-DD");
          let date_start = dayjs(data.date_start).format("YYYY-MM-DD");

          filteredData.push({
            ...data,
            date_end,
            date_start,
          });
          let addData = [
            ...updatedData,
            {
              ...data,
              date_end,
              date_start,
            },
          ];
          setUpdatedData(addData);
          console.log("NEW DATA 2", addData);
          await getUpdatedList(listData, addData);
          props.updated(addData);
          setCountIdAdd(countIdAdd + 1);
          setTempData({
            ...tempData,
            ...addData,
          });
        }
      } else {
        console.log("EDIT DATA DARI DATA YANG SUDAH ADA DARI AWAL");
        let editData = [
          ...updatedData,
          {
            ...data,
          },
        ];
        setUpdatedData(editData);
        console.log("EDIT DATA ", editData);
        await getUpdatedList(listData, editData);
        props.updated(editData);
        setTempData({
          ...tempData,
          ...editData,
        });
      }
    }
    setShowEdit(false);
  };

  return (
    <>

    <div>
    {/* <LogoutModal
    setIsLogoutOpen={setShowDelete}
    isOpen={showDelete}
    onBackToPortal={() => setShowDelete(false)}
    onLogout={() => doDeleteEvent()}
    title={"Delete Data"}
    primaryText={"Yes, Delete"}
    secondaryText={"Cancel"}
    description={
      <p>
        Are you Sure want to delete
        <strong>
          <br />
          {getMessageConfirmDelete()}
        </strong>
        ?
      </p>
    }
  /> */}
  <Delete
        // data={data.updated_at}
        id={getMessageConfirmDelete()}
        delete={showDelete}
        // title={data.first_name}
        act={() => doDeleteEvent()}
        ops={"ops"}
        action={() => setShowDelete(false)}
        // route={ROUTES.CUSTOMER.LIST}
        // refresh={() => fetchData()}
        // token={token}
        // param={param}
      />
      <ModalDateCompany
        isOpen={showEdit}
        onOk={(data) => SaveDateCompany(data)}
        onCancel={() => CancelEdit()}
        closable={true}
        width={440}
        onChangeModal={(event, namespace) =>
          onChangeModalDate(event, namespace)
        }
        selectedMonth={selectedMonth}
        className={style.modalContainer}
        okText="Save"
        getStatus={(e, name,bool) => getStatus(e, name, bool)}
        cancelText="Cancel"
        value={selectedData}
        getEvent={(e) => getEvent(e)}
        dateStartProps={{
          onChange: (e) => onChangeModalDate(e, "date_start"),
        }}
        dateEndProps={{
          onChange: (e) => onChangeModalDate(e, "date_end"),
        }}
        inputProps={{
          placeholder: getStatus(
            selectedData?.description,
            selectedData?.is_operational_active,
            false
          ),
          onChange: (e) => onChangeModalDate(e, "input"),
        }}
      />


      <div className={`mb-[16px] mt-[32px]`}>
        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <DropdownList
            id="ddlmonthpicker"
            name="ddlmonthpicker"
            list={dropdown}
            onChange={(e) => onChange(e)}
            value={selectedMonth}
          />

          <div>
            <PrimaryButton
              action={() => {
                setShowEdit(true);
                setSelectedData({
                  created_by: null,
                  date_end: dayjs(new Date()),
                  date_end_code: getDateCode(
                    dayjs(new Date()).format("YYYY-MM-DD")
                  ),
                  date_start: dayjs(new Date()),
                  date_start_code: getDateCode(
                    dayjs(new Date()).format("YYYY-MM-DD")
                  ),
                  description: "",
                  is_operational_active: false,
                  updated_at: "",
                  flagAdd: true,
                  idAdd: countIdAdd,
                  is_deleted: false,
                });
              }}
              text={"Add Date"}
              prefixIcon={<AddIcon />}
            />
          </div>
        </div>
      </div>

      <div className={style.tableContainer}>
        <CustomTable columns={ListColumn} data={dataSource} />
      </div>
    </div>
    </>
  );
};

export default EditOperationalDate;
